import React from "react";
import styled from "styled-components";
import { colors } from "core/stylesheet";

const Wrap = styled.div``;

const Input = styled.input`
  appearance: none;
  outline: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.2);
  position: relative;
  flex-shrink: 0;
  &:checked:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${colors.brand};
  }
  &:disabled,
  &:disabled + ${Wrap} {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

export default ({ name, value, checked, onChange, title, disabled }) => (
  <label className="flex f6 fw5 mb2 items-center pointer">
    <Input
      name={name}
      value={value}
      checked={checked}
      onChange={onChange}
      type="radio"
      disabled={disabled}
    />
    <Wrap className="ml1">{title}</Wrap>
  </label>
);



// WEBPACK FOOTER //
// ./src/components/generic/form/native/Radio/index.js